var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSadFaceWithPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0076 56.2988H12.963C12.542 56.2988 12.2111 55.9688 12.2111 55.5488V16.5488C12.2111 16.1288 12.542 15.7988 12.963 15.7988H52.0597C52.4808 15.7988 52.8116 16.1288 52.8116 16.5488C52.8116 17.7788 53.8341 18.7988 55.0672 18.7988C56.3002 18.7988 57.3227 17.7788 57.3227 16.5488C57.3227 13.6688 54.9469 11.2988 52.0597 11.2988H12.963C10.0759 11.2988 7.69998 13.6688 7.69998 16.5488V55.5488C7.69998 58.4288 10.0759 60.7988 12.963 60.7988H31.0076C32.2407 60.7988 33.2632 59.7788 33.2632 58.5488C33.2632 57.3188 32.2407 56.2988 31.0076 56.2988Z",
    fill: "#676970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2728 29.0936C62.9059 25.7267 57.3992 25.7267 54.0322 29.0936L41.6028 41.523C40.5644 42.5614 39.998 43.946 39.998 45.4249V53.0084C39.998 54.2986 41.0679 55.3684 42.358 55.3684H49.9415C51.4205 55.3684 52.805 54.802 53.8434 53.7636L66.2728 41.3342C69.6398 37.9673 69.6398 32.4606 66.2728 29.0936ZM62.9373 32.4291C64.4792 33.971 64.4792 36.4569 62.9373 37.9988L62.3709 38.5652L56.8013 32.9955L57.3677 32.4291C58.9096 30.8873 61.3955 30.8873 62.9373 32.4291ZM50.5079 50.4281C50.5079 50.4281 50.1618 50.6484 49.9415 50.6484H44.7181V45.4249C44.7181 45.2047 44.8125 45.0159 44.9383 44.8585L53.4658 36.331L59.0354 41.9006L50.5079 50.4281Z",
    fill: "#676970"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3181 27.4988C24.3224 27.4988 25.1364 28.3128 25.1364 29.3169V32.9534H21.5V29.3169C21.5 28.3128 22.314 27.4988 23.3181 27.4988Z",
    fill: "#676970"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.682 27.4988C36.6861 27.4988 37.5001 28.3128 37.5001 29.3169V32.9534H33.8638V29.3169C33.8638 28.3128 34.6777 27.4988 35.682 27.4988Z",
    fill: "#676970"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4739 40.226C27.4656 40.226 25.8375 41.8541 25.8375 43.8624H22.9284C22.9284 40.2474 25.8589 37.3169 29.4739 37.3169C33.0889 37.3169 36.0193 40.2474 36.0193 43.8624H33.1102C33.1102 41.8541 31.4823 40.226 29.4739 40.226Z",
    fill: "#676970"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFaceWithPen);
export default __webpack_public_path__ + "static/media/sadFaceWithPen.1c2f0b06.svg";
export { ForwardRef as ReactComponent };